import PublicHashSealMask from "./assets/hash-public.webp"

export const PublicHash = ({ publicHash }: { publicHash: string }) => {
	return (
		<div className="relative mb-2 w-[270px]">
			<img
				src={PublicHashSealMask || "/placeholder.svg"}
				alt="Código público do selo"
				className="flex bg-red-400 items-center justify-center"
			/>
			<div className="w-full max-w-[150px] absolute top-1/2 left-1/2 -translate-1/2 flex justify-center rounded-md bg-black/70">
				<p className="text-3xl font-[Doto] font-bold text-center text-white">{publicHash}</p>
			</div>
		</div>
	)
}
